import { FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';

export const PriceText: FC<TypographyProps> = (props) => (
	<Typography variant="b1" textAlign="right" {...props} />
);
